import { searchValueState } from "atoms/atoms";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import SearchIcon from "../SVG/SearchIcon";

const SearchField = () => {
  const setGlobalSearchString = useSetRecoilState(searchValueState);
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");

  const handleSearchButtonClick = () => {
    setGlobalSearchString(searchString);
    navigate("/kereses");
  };

  const handleInputChange = (e) => {
    setSearchString(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setGlobalSearchString(e.target.value);
      navigate("/kereses");
    }
  };

  return (
    <div className="search-container search-container__visible">
      <input
        type="text"
        value={searchString}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      <button className="search" onClick={handleSearchButtonClick}>
        <SearchIcon color="#fff" />
      </button>
    </div>
  );
};

export default SearchField;
